<template>
  <footer class="site-footer">
    <div class="container">
      <div class="row">
        <div class="col-md-4">
          <h3>Contact Us</h3>
          <p>
            <i class="fas fa-map-marker-alt"></i> 123 Medical Center Drive<br>
            Singapore, 123456<br>
            <i class="fas fa-phone"></i> +65 1234 5678<br>
            <i class="fas fa-envelope"></i> info@drmayolee.com
          </p>
        </div>
        <div class="col-md-4">
          <h3>Office Hours</h3>
          <p>
            Monday - Friday: 9:00 AM - 6:00 PM<br>
            Saturday: 9:00 AM - 1:00 PM<br>
            Sunday: Closed
          </p>
        </div>
        <div class="col-md-4">
          <h3>Follow Us</h3>
          <div class="social-links">
            <a href="#"><i class="fab fa-facebook"></i></a>
            <a href="#"><i class="fab fa-instagram"></i></a>
            <a href="#"><i class="fab fa-linkedin"></i></a>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <p>&copy; {{ currentYear }} Dr. Mayo Lee. All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
.site-footer {
  background-color: #333;
  color: #fff;
  padding: 60px 0 20px;
}

.site-footer h3 {
  color: #fff;
  margin-bottom: 20px;
  font-size: 1.2em;
}

.site-footer p {
  color: #ccc;
  line-height: 1.6;
}

.site-footer i {
  margin-right: 10px;
  color: #007bff;
}

.social-links {
  margin-top: 20px;
}

.social-links a {
  color: #fff;
  margin-right: 15px;
  font-size: 1.5em;
  transition: color 0.3s ease;
}

.social-links a:hover {
  color: #007bff;
}

.footer-bottom {
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
}

.footer-bottom p {
  margin: 0;
  font-size: 0.9em;
}
</style>
